<template>
  <div>
    <el-button type="primary" class="creative_detail_create_order" @click="dialogOrder()">立即下单</el-button>
    <el-dialog
      :visible.sync="orderVisible"
      width="680px"
      custom-class="order_modal"
      title="立即下单"
    >
      <el-form
        :model="orderRuleForm"
        :rules="orderRules"
        ref="orderRuleForm"
        label-width="100px"
      >
        <el-form-item label="项目名称" prop="project_name">
          <el-input
            v-model="orderRuleForm.project_name"
            placeholder="请填写项目名称，最多30个汉字"
            maxlength="30"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="所选创意"
          class="originalityList"
        >
          <div  class="originality">
            <el-image
              style="width: 128px; height: 74px; border-radius: 4px"
              :src="detailshow.GoodsPics"
              :preview-src-list="[detailshow.GoodsPics]">
            >
            </el-image>
            <div class="desc">
              <p>{{detailshow.GoodsName}}</p>
              <el-input-number
                v-model="goods_num"
                @change="handleChange"
                :min="1"
                :max="999"
                label="数量"
                controls-position="right"
              ></el-input-number>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="需求描述" prop="requirement">
          <el-input
            type="textarea"
            v-model="orderRuleForm.requirement"
            placeholder="请简要描述您的需求信息，可包含：创意风格、具体产出要求、预算区间、交付期限等。"
            rows="6"
            resize="none"
            maxlength="1000"
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input
            v-model="orderRuleForm.name"
            placeholder="请输入姓名"
            maxlength="30"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input
            v-model="orderRuleForm.phone"
            placeholder="请输手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="notes">
          <el-input
            v-model="orderRuleForm.notes"
            placeholder="如有其他要求，请在此填写"
            maxlength="1000"
          ></el-input>
        </el-form-item>
        <el-form-item label="附件说明" prop="order_files">
          <el-upload
              class="upload-demo"
              name="order_files"
              :action="pubPrefix+upload_url"
              :multiple="true"
              :on-change="(file, fileList) => handleFileChange(4, file, fileList)"
              :data="{upload_type: '4'}"
              :on-success="(res, file, fileList) => handleFIleSuccess(4, res, file, fileList)"
              :before-upload="(file) => beforeFileUpload(4, file)"
              :before-remove="(file, fileList) => removeFileUpload(4, file, fileList)"
              :on-preview="mi_upload_handlepreview"
              :on-exceed="(files, fileList) => overFilelimit(4, files, fileList)"
              :on-progress="handleFileUploadProgress"
              :disabled="isUploading"
              :file-list="orderFileList"
              :headers="upload_headers"
              :limit="5"
              :show-file-list=true
              accept=".pdf, .ppt, .docx, .jpg, .jpeg, .png, .pptx ">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">支持pdf/ppt/docx/jpg/jpeg/png格式文件，最多上传5个附件</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div class="place_order_bottone">
        <el-button class="modal_content_btn_submit" @click="orderFormempty()"
        >取消</el-button
        >
        <el-button
          class="modal_content_btn_submit"
          type="primary"
          @click="submitForm('orderRuleForm')"
        >下单</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="successVisible"
      width="680px"
      custom-class="success_modal"
    >
      <div class="modal_header">
        <img :src="require('@/assets/img/icon_successed@2x.png')"/>
        <p>下单成功</p>
      </div>
      <div class="content">
        <p class="first_text">
          请您添加星云企业微信客服为您提供专属服务
        </p>
        <p>您也可选择等待我们致电联系，我们将在<span style="color: #4573ff">30分钟内</span
        >与您联系</p>
        <img  :src="require('@/assets/img/qrcode.png')"/>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/* eslint-disable */
import * as commfun from "@/common/common.js"
import Cookies from "js-cookie";
var pubPrefix = '/api'
export default {
  name: 'Placeorder',
  props: {
    detailshow: {},
    defaultNum: {type: Number, required: true},
  },
  data() {
    return {
      goods_num:this.defaultNum,
      orderVisible: false,
      successVisible:false,
      internalGoodsNum:1,
      orderRuleForm: {
        uid:"",
        project_name: "",
        requirement: "",
        name: "",
        phone: "",
        notes: "",
      },
      orderRules: {
        project_name: [
          { required: true, message: '请填写项目名称', trigger: 'blur' },
          { max: 30, message: '项目名称最多输入30个汉字', trigger: 'blur' }
        ],
        requirement: [
          { required: true, message: '请输入需求描述', trigger: 'blur' },
          { max: 1000, message: '需求描述最多输入1000个汉字', trigger: 'blur' }
        ],
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { max: 30, message: '姓名最多输入30个汉字', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {pattern: /^1[3456789]\d{9}$/, message: "手机号码格式不正确", trigger: "blur",},
        ],
        notes: [
          { max: 1000, message: '备注最多输入1000个汉字', trigger: 'blur' }
        ],
      },

      upload_url: '/api/index/upload',
      orderFileList: [],
      upload_headers: {},
      pubPrefix: pubPrefix,
      isUploading: false
    };
  },
  watch: {
    defaultNum(newValue) {
      this.goods_num = newValue;
    }
  },
  created() {
    this.orderRuleForm.name = Cookies.get("name")
    this.orderRuleForm.phone = Cookies.get("telphone")

  },
  computed: {
  },
  mounted() {
    // 获取token设置header
    var Authorization = commfun.genAuthorization()
    this.upload_headers = {'Authorization': Authorization}
  },
  methods:{
    handleChange(value) {
      var selfthis = this
      selfthis.goods_num = value;
      this.$emit('numUpdated', value);
      // console.log(value);
    },

    mlogin_clean: function (){
      this.orderVisible = false
    },

    dialogOrder: function (type){
      this.orderVisible = true
    },
    submitForm(formName) {
      var selfthis=this
      if (selfthis.isUploading) {
        commfun.showMessage(selfthis, 'warning', '附件上传中，请稍后！')
        return
      }
      var isvalid=true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
        } else {
          commfun.showMessage(selfthis,'warning',"错误：验证失败，请检查填写信息！")
          isvalid = false
        }
      });
      if(!isvalid) return false
      //附件
      var order_files = ''
      var file_list = selfthis.orderFileList
      if (file_list) {
        for (var j = 0; j < file_list.length; j++) {
          if (file_list[j]['url']) {
            file_list[j]['url1'] = encodeURIComponent(file_list[j]['url'])
            order_files +=   file_list[j]['annex'] + '|' + file_list[j]['hash'] + '|' + file_list[j]['type'] + '|' + file_list[j]['filename'] + '|' + file_list[j]['filesize'] + '|' + file_list[j]['url1'] + '|' + file_list[j]['uid'] + '|' + file_list[j]['username'] + '|' + file_list[j]['datetime'] + ',';
          } else {
            var file_temp = file_list[j]['response']['data']
            file_temp['url1'] = encodeURIComponent(file_temp['url'])
            order_files +=   file_temp['annex'] + '|' + file_temp['hash'] + '|' + file_temp['type'] + '|' + file_temp['filename'] + '|' + file_temp['filesize'] + '|' + file_temp['url1'] + '|' + file_temp['uid'] + '|' + file_temp['username'] + '|' + file_temp['datetime'] + ',';
          }
        }
        order_files = order_files.slice(0, order_files.length - 1);
      }
      var url = "/api/api/order/create"
      var data = selfthis.orderRuleForm
      var goods_infos = {}
      goods_infos[selfthis.detailshow.GoodsId] =selfthis.goods_num
      data.goods_info = JSON.stringify(goods_infos);       //转为JSON字符串
      data.order_type = '1'
      data.order_files = order_files
      commfun.ajaxPost(selfthis,url,data,function (selfthis,data){
        console.log(data)
        selfthis.orderFormempty();
        selfthis.successVisible = true
      },function (selfthis,dataError){
        commfun.showMessage(selfthis,'warning',"错误："+dataError.msg)
      })
    },

    orderFormempty(){
      var selfthis=this
      selfthis.orderRuleForm.project_name = "";
      selfthis.orderRuleForm.requirement = "";
      selfthis.orderRuleForm.notes = "";
      selfthis.orderVisible = false
    },
    handleFileChange(index, file, fileList) {
    },//上传文件
    handleFileUploadProgress (event, file, fileList) {
      this.isUploading = true;
    },
    // 上传完成
    async handleFIleSuccess(index, res, file, fileList) {
      var selfthis = this
      if (res.code != 1000) {
        fileList.pop()
        if (res.msg != undefined && res.msg != '') {
          this.$message.error(res.msg);
        }
        return false;
      }
      res.data.status="success"
      res.data.name=file.name
      res.data.url=res.data.fileurl
      res.data.type = 1
      selfthis.orderFileList = fileList
      selfthis.isUploading = false;
    },//handleFIleSuccess
    // 上传文件
    beforeFileUpload(index, file, fileList){
      // this.upload_data['_csrf-backend'] = csrfToken;
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      const whiteList = ["pdf", "ppt", "pptx", "docx", "jpg", "jpeg", "png", "PDF","PPT", "PPTX", "DOCX", "JPG", "JPEG", "PNG"];
      if (whiteList.indexOf(fileSuffix) === -1) {
        var msg = '只能上传pdf/ppt/docx/jpg/jpeg/png格式文件!'
        this.$message.error(msg);
        return false;
      }else{
        const isLt2M = file.size / 1024 / 1024 < 100;
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 100MB!');
        }
        const isJPG = true;
        return isJPG && isLt2M;
      }
    },
    // 移除文件
    removeFileUpload(index, file, fileList){
      this.orderFileList = fileList
    },
    // 打开文件
    mi_upload_handlepreview:function(file){
      if(file.response){
        window.open(file.response.data.fileurl)
      }else{
        window.open(file.fileurl)
      }
    },
    // 限制文件个数
    overFilelimit(index, files, fileList){
      this.$message.error('最多上传5个附件!');
    },
  },

}
</script>




// WEBPACK FOOTER //
// src/components/Placeorder.vue